var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.24,
    height: 15.24,
    viewBox: "0 0 4.032 4.032",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillRule: "evenodd",
      strokeWidth: 0.0214633
    },
    transform: "matrix(.64316 .76573 -.71775 .6963 -77.19 -137.274)",
    d: "M155.176 26.514h.699v4.992h-.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillRule: "evenodd",
      strokeWidth: 0.0214633
    },
    transform: "matrix(.76573 -.64316 .6963 .71775 -77.19 -137.274)",
    d: "M-40.591 155.51h.699v4.992h-.699z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonClose);
export default __webpack_public_path__ + "static/media/button_close.beeefe6a763e5137385642fe8f105bdf.svg";
export { ForwardRef as ReactComponent };